<template>
    <div id="index" v-cloak>
      <!-- <Hezuo></Hezuo> -->

        <div class="visible-xs min_index">
            <header class="flex_center m_header">
                <i class="esc" @click="goBackward"><img src="@/assets/img/esc_fan.png" alt=""></i>
                <h4 class="header_title">积分记录</h4>
            </header>
            <!-- 内容 -->
            <div class='integral_div'>
                <div class="top_integral flex_items flex_start">
                    <i><img src="@/assets/img/zhuanshi.png" alt=""></i>
                    总积分<span>{{user.score?user.score:0}}</span>
                </div>
                <div class="integral_ul" v-if="lntegral_arr.length>0">
                    <!-- unread -->
                    <div class="integral_li flex_between " v-for="liem in lntegral_arr">
                        <span class="time">{{liem.create_time}}</span>
                        <div class="li_text">
                            {{liem.type}}<span>{{liem.change == 1 ? '+':'-'}}{{liem.score}}</span>
                        </div>
                    </div>
                </div>
                <div class="complete" v-else>
                     <div class="claloadding">
          <div>
            <img
              src="@/assets/img/kkry_pc.gif"
              alt=""
            >
          </div>
          <div>空空如也</div>
        </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import "@/assets/js/swiper.animate1.0.3.min.js";
    import "@/assets/css/animate.min.css";
    import "@/assets/css/video-js.min.css";
import Hezuo from '@/components/tool/m_hezuo.vue'

    export default {
        name: "index",
        data() {
            return {
                user: {},//用户信息
                page: 1,
                lntegral_arr: [],
            };
        },
        computed: {},
        components: {
Hezuo
        },
        watch: {

        },
        methods: {
            goBackward() {//返回上一页
                this.$router.replace("/m_my");
            },
            getUser() {
                let that = this;
                this.REFRESH_USER();

                that.user = this.USER();
                that.getLntegral();

            },
            getLntegral() {//获取积分明细
                let that = this;
                if (this.page == 1) {
                    this.lntegral_arr = [];
                }
                this.$post('score_log', {
                    member_id: this.USER().id,
                    limit: 20,
                    page: this.page,
                }).then(res => {
                    that.lntegral_arr = that.lntegral_arr.concat(res.data.data);
                })
            },


        },
        mounted() {
            this.getUser();
            this.getShare();
            if (this._isMobile()) {

            } else {
                // alert("pc端");
                this.$router.replace("/");
            }
            let that = this;
            $(window).scroll(function () {
                var scrollTop = $(this).scrollTop();
                var scrollHeight = $(document).height();
                var windowHeight = $(this).height();
                if (scrollTop + windowHeight + 2 >= scrollHeight) {
                    that.page++;
                    that.getLntegral();
                }
            });
        }
    };
</script>

<style scoped>
    html,
    body {
        max-width: 100vw;
    }


    .visible-xs {
        width: 100vw;
        overflow: hidden;
        padding-top: 0rem;
    }

    /* 内容 */
    .integral_div .top_integral {
        height: 3rem;
        background: rgba(255, 172, 6, .2);
        padding: 0 2rem;
        font-size: 1.5;
        color: #333;
    }
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
    .top_integral>i {
        width: 2rem;
        margin-right: 1rem;
    }

    .integral_div .top_integral>span {
        color: #F5AB16;
        margin-left: 1rem;
    }

    .integral_div .integral_li {
        padding: 0 1rem 0 2.5rem;
        height: 5.5rem;
        border-bottom: .05rem solid #DFDFDF;
        position: relative;
    }

    .integral_li .time {
        font-size: 1.4rem;
        width: 10rem;
        color: #999;
    }

    .integral_li .li_text {
        flex: 1;
        margin-left: 1rem;
        font-size: 1.5rem;
        color: #333;
    }

    .integral_li .li_text>span {
        color: #FFAC06;

    }

    .integral_div .integral_li.unread::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 1.5rem;
        transform: translateY(-50%);
        width: .4rem;
        height: .4rem;
        border-right: 50%;
        background: #333333;
    }
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_integral.vue